import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';
import '../Registration.css';

const Investor = () => {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate('/registration');
  };
  return (
    <div className="container mt-3">
      <div className="back-header">
        <Button variant="outline-primary backBtn" onClick={handleBack}>Back</Button>
        <h1 className="homepage-heading">Register New Investor at Business Xchange!</h1>
      </div>
    </div>
  );
};

export default Investor;
